import React, { useState } from 'react'
import {
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAtom } from 'jotai'
import { isDevEnabledAtom } from 'atoms'

const DebugSettings = () => {
  const { t } = useTranslation()
  const [isDevEnabled, setIsDevEnabled] = useAtom(isDevEnabledAtom)
  const [modalOpen, setModalOpen] = useState(false)
  const [password, setPassword] = useState('')
  const [hasEnteredPassword, setHasEnteredPassword] = useState(false)
  const correctPassword = 'jmdsjd'

  const handleCheckboxClick = () => {
    if (!isDevEnabled && !hasEnteredPassword) {
      setModalOpen(true)
    } else {
      setIsDevEnabled(!isDevEnabled)
    }
  }

  const handlePasswordSubmit = () => {
    if (password === correctPassword) {
      setIsDevEnabled(true)
      setHasEnteredPassword(true)
      setModalOpen(false)
      setPassword('')
    } else {
      alert(t('incorrectPassword'))
    }
  }

  const handleClose = () => {
    setModalOpen(false)
    setPassword('')
  }

  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={isDevEnabled}
            onClick={(e) => {
              e.preventDefault()
              handleCheckboxClick()
            }}
            color="primary"
          />
        }
        label={t('activateDevelopment')}
      />

      <Dialog open={modalOpen} onClose={handleClose}>
        <DialogTitle>{t('enterPassword')}</DialogTitle>
        <DialogContent>
          <TextField
            label={t('password')}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            {t('cancel')}
          </Button>
          <Button onClick={handlePasswordSubmit} color="primary">
            {t('confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DebugSettings
